/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDiaglabSampleItems } from 'app/entities/diaglab-sample-item/diaglab-sample-item.reducer';
import { getEntities as getDiaglabAssistants } from 'app/entities/diaglab-assistant/diaglab-assistant.reducer';
import { SampleStatusEvent } from 'app/shared/model/enumerations/sample-status-event.model';
import { createEntity, getEntity, reset, updateEntity } from './diaglab-sample-item-status.reducer';

export const DiaglabSampleItemStatusUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const diaglabSampleItems = useAppSelector(state => state.diaglabSampleItem.entities);
  const diaglabAssistants = useAppSelector(state => state.diaglabAssistant.entities);
  const diaglabSampleItemStatusEntity = useAppSelector(state => state.diaglabSampleItemStatus.entity);
  const loading = useAppSelector(state => state.diaglabSampleItemStatus.loading);
  const updating = useAppSelector(state => state.diaglabSampleItemStatus.updating);
  const updateSuccess = useAppSelector(state => state.diaglabSampleItemStatus.updateSuccess);
  const sampleStatusEventValues = Object.keys(SampleStatusEvent);

  const handleClose = () => {
    navigate(`/diaglab-sample-item-status${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDiaglabSampleItems({}));
    dispatch(getDiaglabAssistants({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.eventDate !== undefined && typeof values.eventDate !== 'number') {
      values.eventDate = Number(values.eventDate);
    }

    const entity = {
      ...diaglabSampleItemStatusEntity,
      ...values,
      diaglabSampleItem: diaglabSampleItems.find(it => it.id.toString() === values.diaglabSampleItem?.toString()),
      collector: diaglabAssistants.find(it => it.id.toString() === values.collector?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          statusEvent: 'COLLECTED',
          ...diaglabSampleItemStatusEntity,
          diaglabSampleItem: diaglabSampleItemStatusEntity?.diaglabSampleItem?.id,
          collector: diaglabSampleItemStatusEntity?.collector?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.diaglabSampleItemStatus.home.createOrEditLabel" data-cy="DiaglabSampleItemStatusCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.diaglabSampleItemStatus.home.createOrEditLabel">
              Create or edit a DiaglabSampleItemStatus
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="diaglab-sample-item-status-id"
                  label={translate('tinyMedicRestApp.diaglabSampleItemStatus.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSampleItemStatus.statusEvent')}
                id="diaglab-sample-item-status-statusEvent"
                name="statusEvent"
                data-cy="statusEvent"
                type="select"
              >
                {sampleStatusEventValues.map(sampleStatusEvent => (
                  <option value={sampleStatusEvent} key={sampleStatusEvent}>
                    {translate(`tinyMedicRestApp.SampleStatusEvent.${sampleStatusEvent}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSampleItemStatus.active')}
                id="diaglab-sample-item-status-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSampleItemStatus.cursor')}
                id="diaglab-sample-item-status-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSampleItemStatus.lastUpdated')}
                id="diaglab-sample-item-status-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSampleItemStatus.microSec')}
                id="diaglab-sample-item-status-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSampleItemStatus.timestampEntry')}
                id="diaglab-sample-item-status-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSampleItemStatus.eventDate')}
                id="diaglab-sample-item-status-eventDate"
                name="eventDate"
                data-cy="eventDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="diaglab-sample-item-status-diaglabSampleItem"
                name="diaglabSampleItem"
                data-cy="diaglabSampleItem"
                label={translate('tinyMedicRestApp.diaglabSampleItemStatus.diaglabSampleItem')}
                type="select"
                required
              >
                <option value="" key="0" />
                {diaglabSampleItems
                  ? diaglabSampleItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="diaglab-sample-item-status-collector"
                name="collector"
                data-cy="collector"
                label={translate('tinyMedicRestApp.diaglabSampleItemStatus.collector')}
                type="select"
              >
                <option value="" key="0" />
                {diaglabAssistants
                  ? diaglabAssistants.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/diaglab-sample-item-status" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DiaglabSampleItemStatusUpdate;
